import Header from './components/Header';
import HeaderContainer from './containers/Header';
import {
  canUserViewDashboard,
  canUserViewPayoutReport,
  canUserViewAnalytics,
  canUserViewReports,
  canUserViewTimeReport,
} from '../../../../../common/helpers/users';
import { canUserViewSettlementReport } from '../../../settlementReport/utils';

const items = [
  {
    label: 'Leaderboard',
    to: '/reports/dash',
    displayIf: ({ permissions, activeType }) => canUserViewDashboard(permissions) && activeType === 'shop',
    primary: true,
  },
  {
    label: 'Total Gross Sales',
    to: '/reports/dashboard/v2',
    displayIf: ({ permissions }) => canUserViewDashboard(permissions),
    primary: true,
  },
  {
    label: 'Settlement',
    to: '/reports/settlement',
    displayIf: ({ user, shop }) => canUserViewSettlementReport(user, shop),
    primary: true,
  },
  {
    label: 'Sales by Service',
    to: '/reports/sales/v2',
    displayIf: ({ permissions, activeType }) => canUserViewDashboard(permissions) || activeType === 'brand',
    primary: true,
  },
  {
    label: 'Sales by Product',
    to: '/reports/sales-by-product',
    displayIf: ({ permissions, activeType }) => canUserViewDashboard(permissions) || activeType === 'brand',
    primary: true,
  },
  {
    label: 'Sales By Barber',
    to: '/reports/barbers',
    displayIf: ({ permissions, activeType }) => canUserViewDashboard(permissions) && activeType === 'shop',
    primary: true,
  },
  {
    label: 'Barber Sales Summary',
    to: '/reports/barbers-summary',
    displayIf: ({ permissions, activeType }) => canUserViewDashboard(permissions) && activeType === 'shop',
  },
  {
    label: 'Sales by Barber',
    to: '/reports/barbers',
    displayIf: ({ activeType }) => activeType === 'brand',
    primary: true,
  },
  {
    label: 'Analytics',
    to: '/reports/analytics',
    displayIf: ({ permissions, activeType }) => canUserViewAnalytics(permissions) || activeType === 'brand',
  },
  {
    label: 'Commission Payout',
    to: '/reports/payouts',
    displayIf: ({ user, shop, activeType, canUseCommissionReporting }) =>
      canUseCommissionReporting && (canUserViewPayoutReport(user, shop) || activeType === 'brand'),
  },
  {
    label: 'Appointments',
    to: '/reports/appointments',
  },
  {
    label: 'Deposits',
    to: '/reports/deposits',
    displayIf: ({ activeType, barber }) => activeType === 'shop' || (barber && barber.bankAccountId !== null),
  },
  {
    label: 'Daily Summary',
    to: '/reports/daily-summary',
    displayIf: ({ permissions, activeType }) => canUserViewReports(permissions) && activeType === 'brand',
  },
  {
    label: 'Time Track Report',
    to: '/reports/time-track',
    displayIf: ({ permissions, activeType }) => activeType === 'brand' || (canUserViewTimeReport(permissions) && activeType === 'shop'),
  },
  {
    label: 'Cash Register History',
    to: '/reports/cash-register-history',
    displayIf: ({ permissions, activeType }) => canUserViewReports(permissions) && activeType === 'brand',
  },
];

export default HeaderContainer(items)(Header);
